import { Box, Flex, Text, ThemeFontSizeVariable, ThemeSpaceVariable } from "@caspeco/casper-ui-library";
import { type JSX } from "react";
import { BackButton } from "./back-button";
import { useTranslation } from "react-i18next";
import CustomEventWrapper from "./application-insights/custom-event-wrapper";
import FilterSettings from "./filter/filter-settings";
import { TrackEventNames } from "./application-insights/track-event-name-enum";
import { useNavigationContext } from "../hooks/use-navigation-context";

type props = {
	subheader?: boolean;
	title: string;
	addButton?: JSX.Element;
	headerButtons?: JSX.Element;
	showFilter?: boolean;
	moreButton?: JSX.Element;
};

export const PageHeader = ({ subheader, title, addButton, headerButtons, showFilter, moreButton }: props) => {
	const { t } = useTranslation();
	const { back } = useNavigationContext();

	return (
		<Flex
			justifyContent={"space-between"}
			direction={"row"}
			alignItems={"center"}
			w={"100%"}
			px={ThemeSpaceVariable.Medium}
			py={ThemeSpaceVariable.Small}
			height={"56px"}
		>
			{subheader ? (
				<>
					<Box pos={"absolute"} w={"100%"} left={0}>
						<Text textAlign={"center"} fontSize={ThemeFontSizeVariable.Large} data-testid="page-title">
							{t(title)}
						</Text>
					</Box>
					<BackButton onClick={back} />
				</>
			) : (
				<Text
					textAlign={"center"}
					fontSize={ThemeFontSizeVariable.XLarge}
					fontWeight={"bold"}
					data-testid="page-title"
				>
					{t(title)}
				</Text>
			)}

			<Flex>
				{headerButtons && headerButtons}
				{showFilter && (
					<CustomEventWrapper eventName={TrackEventNames.Filter} type="toggle_button">
						<FilterSettings />
					</CustomEventWrapper>
				)}
				{moreButton && moreButton}
				{addButton && addButton}
			</Flex>
		</Flex>
	);
};
